<button class="left1"  mat-raised-button   (click)="btnClick();">
    <span class="style">Create a lead</span>
</button>



<!---------------------------------new ui---------------------------------------------------->


    <section class="content-header ">
   
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Leads</h1>
    </div>
    </div>
   
    </section>
    
    <section class="content">
    
    <div class="card">
    <div class="card-header">
    
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 18%">
    First Name
    </th>
    <th style="width: 12%">
    Last Name
    </th>

    <th style="width: 12%">
    Contact_1
    </th>

    <th style="width: 12%">
    Contact_2
    </th>

    <th style="width: 20%">
    Email
    </th>
    
     
    <th>

    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
    {{c.first_name}}
    </a>
    </td>

    <td>
    <a>
    {{c.last_name}}
    </a>
    </td>
    
    <td>
    {{c.contact_1}}
    </td>

    <td>
    {{c.contact_2}}
    </td>

    
    <td>
    {{c.email}}
    </td>
    
    
    <td class="project-actions text-right">
    
    <a class="btn btn-info btn-sm left" (click)='getValue(c._id);LeadDetails();'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
   
    <a class="btn btn-danger btn-sm left" data-toggle="modal" data-target="#modal-sm" (click)='SetDeletedLead(c._id,c.first_name);'>
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
    
    </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
 <!----------------------delete conformation box-------------------------------------->
 <div class="modal fade" id="modal-sm" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
    <div class="modal-content">
    
    <div class="modal-body">
    <p>Are you sure to delete {{deleteName}}?</p>
    </div>
    <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-default" data-dismiss="modal">No</button>
    <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="DeleteLead();">Yes</button>
    </div>
    </div>
    
    </div>
    
    </div>

<!----------------------paging---------------------->
<div class="col-sm-12 col-md-7">
    <div class="dataTables_paginate paging_simple_numbers" id="example2_paginate">
        <ul class="pagination">
            <li class="paginate_button page-item previous" id="example2_previous">
            <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link">Previous</a></li>

            <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link">{{count+1}}</a></li>
           
            <li class="paginate_button page-item next" id="example2_next">
            <a (click)="clicks_next()" aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
        </ul>
    </div></div>